import React, { useState, useEffect } from 'react';

import CoinCard from './CoinCard';
import _ from '../services/comparators';
import log from '../services/log';
import auth from '../services/auth';

import '@rmwc/list/styles';
import AlertHistoryCard from './AlertHistoryCard';
import UnlockProCard from './UnlockProCard';

function AlertsList(props) {
  const displayRsiPeriod = props.filters.sort.rsi_1d[0] === 1 ? '1d' : '4h';
  const isPro = auth.isProMembership();
  const isTrial = auth.isFreeTrial();
  const shouldHideFreeAlerts = !isPro && !isTrial;

  const filterAlerts = (alerts, filters) => {
    //log.traceTag('AlertsList filterCoins sort', filters)

    if (!alerts) return; 

    var filteredAlerts = alerts.filter(a => props.coins.map(c => c.coin).includes(a.coin)).map(a => {
      const coin = props.coins.find(c => c.coin === a.coin)
      return {
        ...a,
        ...coin
      }
    })

    //log.traceTag('filteredAlerts', filteredAlerts)

    if (filters.search !== '' && filters.search !== '$$$'){
      filteredAlerts = filteredAlerts.filter(a => a.coin.includes(filters.search))
    }

    if (filters.sort.rank[0] === 1){
      return (filters.sort.rank[1] === 1) ? filteredAlerts.sort(_.byRank) : filteredAlerts.sort(_.byRankDesc) 
    }

    if (filters.sort._1h[0] === 1){
      return (filters.sort._1h[1] === 1) ? filteredAlerts.sort(_.by1h) : filteredAlerts.sort(_.by1hDesc) 
    }

    if (filters.sort._24h[0] === 1){
      return (filters.sort._24h[1] === 1) ? filteredAlerts.sort(_.by24h) : filteredAlerts.sort(_.by24hDesc) 
    }

    if (filters.sort._7d[0] === 1){
      return (filters.sort._7d[1] === 1) ? filteredAlerts.sort(_.by7d) : filteredAlerts.sort(_.by7dDesc) 
    }

    if (filters.sort._30d[0] === 1){
      return (filters.sort._30d[1] === 1) ? filteredAlerts.sort(_.by30d) : filteredAlerts.sort(_.by30dDesc) 
    }

    if (filters.sort.rsi[0] === 1){
      return (filters.sort.rsi[1] === 1) ? filteredAlerts.sort(_.byRSI) : filteredAlerts.sort(_.byRSIDesc) 
    }

    if (filters.sort.rsi_1d[0] === 1){
      return (filters.sort.rsi_1d[1] === 1) ? filteredAlerts.sort(_.byRSI_1D) : filteredAlerts.sort(_.byRSI_1D_Desc) 
    }

    if (filters.sort.timestamp[0] === 1){
      return (filters.sort.timestamp[1] === 1) ? filteredAlerts.sort(_.byTimestamp) : filteredAlerts.sort(_.byTimestampDesc) 
    }

    return filteredAlerts.sort(_.byTimestamp) 
  }

  const [filteredAlerts, setFilteredAlerts] = useState(filterAlerts(props.alerts, props.filters))

  useEffect(() => {
    setFilteredAlerts(filterAlerts(props.alerts, props.filters))
  }, [props.coins, props.filters, props.alerts])

  return (
    <div className="my-2">
        {filteredAlerts && filteredAlerts.length > 0 && filteredAlerts.map((alert, index) => {
          return(
            <React.Fragment key={`${alert.coin}-${alert.timestamp || index}`}>
              {!props.isHistory &&
                <>
                  <div className="striped-list-row" style={{ backgroundColor: index % 2 === 1 ? 'var(--list-stripe-background-color)' : 'transparent' }}>
                    <CoinCard hideForFree={(index) > 4 && shouldHideFreeAlerts && !props.landing} small={props.small} isAlert={true} coin={props.coins.find(c => c.coin === alert.coin)} signal={alert} displayRsiPeriod={displayRsiPeriod} onCoinSelected={(coinSymbol) => {
                      props.onCoinSelected(coinSymbol)
                    }}></CoinCard>
                  </div>
                  <div className="my-2"/>
                </>
              }
              {(index === 4) && !isPro && !props.landing &&
                <UnlockProCard text="Unlock Access To All 24h RSI Alerts"></UnlockProCard>
              }
              {props.isHistory &&
                <>
                  <div className="striped-list-row" style={{ backgroundColor: index % 2 === 1 ? 'var(--list-stripe-background-color)' : 'transparent' }}>
                    <AlertHistoryCard hideForFree={!auth.isUnlocked() && !props.landing} small={props.small} isAlert={true} coin={props.coins.find(c => c.coin === alert.coin)} signal={alert} onCoinSelected={(coinSymbol) => {
                      props.onCoinSelected(coinSymbol)
                    }}></AlertHistoryCard>
                  </div>
                  <div className="my-2"/>
                </>
              }
            </React.Fragment>
          )})
        }
        {filteredAlerts && filteredAlerts.length === 0 &&
          <>
            <div className="my-4 text-center ">
              <div className="text-muted my-2">
                <span className="dashed">No{(props.portfolioView) ? ' Portfolio ' : ' '}Alerts for Last 24h</span></div>
              <div >
              <img className="svg-container" src="https://img.icons8.com/fluency/96/000000/fire-alarm-button.png"/>
                </div>
            </div>
          </>
        }
    </div>
  );
};

AlertsList.defaultProps = {
  isHistory: false,
  filters: {
    sort: {
      rank: [0,0],
      _1h: [0,0],
      _24h: [0,0],
      _7d: [0,0],
      _30d: [0, 0],
      rsi: [0,0],
      rsi_1d: [0,0],
      timestamp: [1, 1]
    },
    view: {
      list: false,
      heatmap: true,
      alerts: false
    },
    search: ''
  }
};

export default AlertsList;
